module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n5r1n2n-3b5417a81df4dd67412a568f0d4845e9.svg";